export * from './livestream.types';

import type { ILivestream, ILivestreamData } from '@/entities';

export class Livestream implements ILivestream {
  id = '';
  header = '';
  description = '';
  imageUrl = '';
  dateTime = new Date();
  source = '';
  sourceUrl = '';
  isChatEnabled = false;

  constructor(data: ILivestreamData) {
    Object.assign(this, data);
  }

  get isYoutube(): boolean {
    return this.source.toLowerCase() === 'youtube';
  }

  get isTwitch(): boolean {
    return this.source.toLowerCase() === 'twitch';
  }

  get normalizedSrc(): string {
    return this.isYoutube ? this.normalizeYoutubeSrc() : this.normalizeTwitchSrc();
  }

  getAutoplaySourceUrl(isMobile: boolean = false): string {
    const src: string = this.normalizedSrc;
    return `${src}${src.indexOf('?') < 0 ? '?' : '&'}autoplay=${!isMobile}&mute=${!isMobile}`;
  }

  get youtubeVideoId(): string {
    const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    const match = this.sourceUrl.match(regExp);
    return match && match[7].length == 11 ? match[7] : '';
  }

  get youtubeChatUrl(): string {
    if (this.youtubeVideoId) {
      return `https://www.youtube.com/live_chat?v=${this.youtubeVideoId}&embed_domain=${window.location.hostname}&redirect_uri=${window.location.hostname}&theme=dark`;
    }
    return '';
  }

  normalizeYoutubeSrc() {
    if (!this.sourceUrl) return '';
    return this.sourceUrl.replace('watch?v=', 'embed/');
  }

  normalizeTwitchSrc(): string {
    if (!this.sourceUrl) return '';
    if (!this.sourceUrl.includes('/videos/') && !this.sourceUrl.includes('video=v')) {
      return (
        this.sourceUrl
          .replace('www.twitch.tv/', 'player.twitch.tv/?channel=')
          .replace('www.example.com', window.location.hostname) +
        (!this.sourceUrl.includes('parent=') ? '&parent=' + window.location.hostname : '')
      );
    }
    return (
      this.sourceUrl.replace('www.twitch.tv', 'player.twitch.tv').replace('/videos/', '/?video=v') +
      (this.sourceUrl.indexOf('autoplay') < 0 ? '&autoplay=false' : '')
    );
  }
}
